<template>
  <div class="goods-list">
    <div class="goods-list__header">
      <game-selector :selectedGame="filters.game" @select="onGameSelect" />
      <div class="goods-list__header__controls">
        <primary-button to="/goods/create">Create Goods</primary-button>
      </div>
    </div>
    <div class="goods-list__filters">
      <search-input
        v-model="filters.name"
        :placeholder="'Поиск по названию...'"
        @input="onSearchInput"
      />
    </div>

    <goods-table
      :items="goods"
      :loading="loading"
      :pagination="pagination"
      @edit="onEditItem"
      @next-page="nextPage"
      @prev-page="prevPage"
      @go-to-page="goToPage"
    />
  </div>
</template>

<script>
import GameSelector from '../../../components/ui/GameSelector/GameSelector.vue'
import PrimaryButton from '../../../components/ui/PrimaryButton/PrimaryButton.vue'
import SearchInput from '../../../components/ui/SearchInput/SearchInput.vue'
import GoodsTable from '../../../components/GoodsTable/GoodsTable.vue'
import { getGoodsList } from '@/apis'
import { Games } from '@/constants'

export default {
  components: { GameSelector, SearchInput, PrimaryButton, GoodsTable },
  name: 'GoodsListView',
  data() {
    return {
      filters: {
        name: '',
        game: Games.ADOPTME
      },
      goods: [],
      loading: false,
      pagination: {
        skip: 0,
        limit: 10,
        total: 0
      },
      searchTimeout: null
    }
  },
  mounted() {
    this.initializeGameFromQuery()
    this.loadGoods()
  },
  beforeDestroy() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }
  },
  methods: {
    initializeGameFromQuery() {
      const gameParam = this.$route.query.game
      if (gameParam) {
        const gameValue = parseInt(gameParam)
        if (Object.values(Games).includes(gameValue)) {
          this.filters.game = gameValue
        }
      }

      const nameParam = this.$route.query.name
      if (nameParam) {
        this.filters.name = nameParam
      }
    },
    onGameSelect({ game }) {
      this.filters.game = game
      this.pagination.skip = 0
      this.filters.name = ''
      this.updateQueryParams()
      this.loadGoods()
    },
    updateQueryParams() {
      const query = { ...this.$route.query }
      if (this.filters.game !== Games.ADOPTME) {
        query.game = this.filters.game
      } else {
        delete query.game
      }

      if (this.filters.name) {
        query.name = this.filters.name
      } else {
        delete query.name
      }

      this.$router.replace({ query })
    },
    async loadGoods() {
      this.loading = true
      try {
        const currentPage = Math.floor(this.pagination.skip / this.pagination.limit) + 1
        const data = await getGoodsList({
          page: currentPage,
          limit: this.pagination.limit,
          name: this.filters.name,
          game: this.filters.game
        })

        this.goods = data.items || []
        this.pagination.total = data.total || 0
        this.pagination.pages = data.pages || 0
      } catch (error) {
        console.error('Error loading goods:', error)
        this.goods = []
        this.pagination.total = 0
      } finally {
        this.loading = false
      }
    },
    onSearchInput() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout)
      }

      this.searchTimeout = setTimeout(() => {
        this.pagination.skip = 0
        this.updateQueryParams()
        this.loadGoods()
      }, 500)
    },
    nextPage() {
      if (this.pagination.skip + this.pagination.limit < this.pagination.total) {
        this.pagination.skip += this.pagination.limit
        this.loadGoods()
      }
    },
    prevPage() {
      if (this.pagination.skip > 0) {
        this.pagination.skip = Math.max(0, this.pagination.skip - this.pagination.limit)
        this.loadGoods()
      }
    },
    goToPage(page) {
      this.pagination.skip = page * this.pagination.limit
      this.loadGoods()
    },
    onEditItem(item) {
      this.$router.push(`/goods/${item.id}/edit`)
    }
  }
}
</script>

<style lang="scss" scoped>
.goods-list {
  display: flex;
  flex-direction: column;
  gap: 15px;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
